export const conflictingSources: string[] = [
  'One manual explains forklifts.',
  'Another document covers excavators.',
  'A separate resource contains crane diagrams.',
  'Another explains aerial work platforms.',
]

export const symptoms: string[] = [
  'And when you need material for bulldozers, loaders, graders or road construction equipment...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next training session arrives.'

export const needsList: string[] = [
  'You need a clear technical explanation.',
  'You need a professional machinery diagram.',
  'You need realistic examples.',
  'You need activities your students can understand.',
  'You need structured teaching resources.',
  'And you need a way to assess what they’ve learned.',
]

export const searchQuestions: string[] = [
  'What machinery topic should I teach today?',
  'Where can I find complete technical training material?',
  'How can I explain complicated equipment components more clearly?',
  'Where can I find professional machinery illustrations?',
  'How do I teach equipment limitations and workplace safety concepts?',
  'What realistic industrial scenarios can I use?',
  'How can I organize lessons for beginners and experienced students?',
  'Where can I find technical diagrams and reference sheets?',
  'How can I make my classes more visually engaging?',
  'How do I evaluate equipment knowledge and hazard recognition?',
  'How can I prepare better lessons without wasting hours every week?',
]

export const painPoints: string[] = [
  'Hours spent searching for suitable equipment diagrams.',
  'Preparing every lesson from scratch.',
  'Using outdated or incomplete teaching materials.',
  'Trying to explain complex mechanical concepts through long paragraphs.',
  'Searching for technical illustrations across different websites.',
  'Repeating the same examples because creating new activities takes too long.',
  'Organizing disconnected training documents.',
  'Struggling to demonstrate the differences between machinery categories.',
  'Developing workplace scenarios independently.',
  'Preparing knowledge assessments without a consistent structure.',
  'Losing valuable preparation time.',
  'And constantly wondering whether you have enough material for your next class.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO ORGANIZE THE LESSON.',
  'WHAT HAZARDS TO IDENTIFY.',
  'HOW TO ASSESS UNDERSTANDING.',
]
